export interface NotificationTab {
  label: string;
  selected?: boolean;
  callback?: () => void;
}
